import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { useLocation } from "@reach/router"

import TextInput from "../../components/TextInput"
import TextArea from "../../components/TextArea"
import ArrowRight from "../../components/icons/ArrowRight"

const ContactOverlayForm = ({ formFields, requiredText, btnName }) => {
  const [formData, setFormData] = useState({})
  const [sent, setSent] = useState(false)
  const [, setServerState] = useState({
    submitting: false,
    status: null,
  })
  const location = useLocation()
  const isSpanishSite = location.pathname.includes("/es/")

  let disabled = Object.values(formData).length !== formFields.length || Object.values(formData).some(field => field.length === 0)

  const emailEndpoints = () => {
    const defaultEndpoint = "https://getform.io/f/6992da59-aead-456d-9dab-dc6b53b28a54"
    const anniversaryEndpoint = "https://getform.io/f/4f715269-c1a4-4cdb-a51b-94f01cd7202b"
    const spanishAnniversaryEndpoint = "https://getform.io/f/9c2334bf-b441-4ed7-a8d8-83f1934f4267"

    return location.pathname.includes("anniversary") || location.pathname.includes("aniversario")
      ? isSpanishSite
        ? spanishAnniversaryEndpoint
        : anniversaryEndpoint
      : defaultEndpoint
  }

  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    })
    if (ok) {
      form.reset()
      setSent(true)
      setFormData({})
    }
  }

  const handleOnSubmit = e => {
    e.preventDefault()
    const form = e.target

    setServerState({ submitting: true })
    axios({
      method: "post",
      url: emailEndpoints(),
      data: new FormData(form),
    })
      .then(() => {
        handleServerResponse(true, "Thanks!", form)
        setSent(true)
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error, form)
      })
  }

  const onInputChange = inputData => {
    setFormData({ ...formData, ...inputData })
  }

  useEffect(() => {
    setSent(false)
  }, [])

  return (
    <div>
      {sent ? (
        <div>
          <h2 className="text-white">{isSpanishSite ? "¡Muchas gracias!" : "Vielen Dank!"}</h2>
        </div>
      ) : (
        <form className="grid grid-cols-2 gap-4" method="POST" onSubmit={handleOnSubmit}>
          {formFields.map((field, index) => {
            return index !== formFields.length - 1 ? (
              field.fieldSize === "small" ? (
                <TextInput onInputChange={onInputChange} label={field.fieldName} key={index + field.fieldName + "b"} />
              ) : (
                <div className="col-span-2" key={index + field.fieldName + "a"}>
                  <TextInput onInputChange={onInputChange} label={field.fieldName} />
                </div>
              )
            ) : (
              <div className="col-span-2 pt-4" key={index + field.fieldName + "c"}>
                <TextArea onInputChange={onInputChange} label={field.fieldName} />
              </div>
            )
          })}
          <div className="col-span-2 sm:mt-10 md:mt-12">
            <p className="text-white text-p3 mb-4">* {requiredText}</p>
            <button
              className={
                "bg-secondary xxs:mb-12 w-60 h-14 flex justify-center items-center " +
                (disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : "")
              }
              type="submit"
              value="Submit"
            >
              <div className={"flex items-center space-x-2.5 text-white"}>
                <p className="text-p2 font-bold tracking-wider">{btnName}</p>
                <ArrowRight className="mt-0.5" />
              </div>
            </button>
          </div>
        </form>
      )}
    </div>
  )
}

export default ContactOverlayForm

ContactOverlayForm.propTypes = {
  formFields: PropTypes.array,
  requiredText: PropTypes.string,
  btnName: PropTypes.string,
}
